/* Copyright (c) 2017 Backpack Health LLC */

/* global window, document */

import localstore from 'store';

const StorageKeys = {
  AUTH_TOKEN: 'authToken',
  TOKEN_TYPE: 'tokenType',
  LAST_ACTIVE_TIME: 'lastActiveTime',
  PUBLIC_PASSCODE: 'publicPasscode',
  PUBLIC_HASH: 'publicHash',
  JOIN_GROUP_INTENT: 'joinGroupIntent',
  LAST_ACCESSED_PROFILES: 'lastAccessedProfiles',
  LOGOUT_EVENT: 'logoutEvent',
  VERSION_CHECK: 'versionCheck',
  DEEP_LINK: 'deepLink',
  ACTIVE_PROFILE: 'activeProfile',
};



localstore.clear = (a) => {
  const v = [];
  PersistantValues.forEach(pv => {
    v.push([pv, pv.get()]);
  });

  localstore.clearAll(a);

  v.forEach(p => {
    p[0].set(p[1]);
  });
}

const sessionstore = window.sessionStorage
  ? {
    set(key, value) {
      window.sessionStorage.setItem(key, value);
    },

    get(key) {
      return window.sessionStorage.getItem(key);
    },

    remove(key) {
      window.sessionStorage.removeItem(key);
    },

    clear() {
      window.sessionStorage.clear();
    },
  }
  : {
    set(key, value) {
      localstore.set(key, value);
    },

    get(key) {
      return localstore.get(key);
    },

    remove(key) {
      localstore.remove(key);
    },

    clear() {
      const v = [];
      PersistantValues.forEach(st => {
        v.push([st, st.get()]);
      });

      localstore.clearAll();

      PersistantValues.forEach(st => {
        st[0].set(st[1]);
      });
    },
  };

const authToken = {

  init(duration, token) {
    localstore.set(StorageKeys.AUTH_TOKEN, token);
  },

  set(token) {
    localstore.set(StorageKeys.AUTH_TOKEN, token);
  },

  get() {
    return localstore.get(StorageKeys.AUTH_TOKEN) || '';
  },

  remove() {
    localstore.remove(StorageKeys.AUTH_TOKEN);
  },

  decode() {
    const tokenParts = this.get().split('.');
    return tokenParts[1] ? window.JSON.parse(window.atob(tokenParts[1])) : {};
  },

};

const lastActiveTime = {

  init(value) {
    localstore.set(StorageKeys.LAST_ACTIVE_TIME, value);
  },

  set(value) {
    localstore.set(StorageKeys.LAST_ACTIVE_TIME, value);
  },

  get() {
    return localstore.get(StorageKeys.LAST_ACTIVE_TIME) || '';
  },

  remove() {
    localstore.remove(StorageKeys.LAST_ACTIVE_TIME);
  },

};


const publicPasscode = {

  init(value) {
    localstore.set(StorageKeys.PUBLIC_PASSCODE, value);
  },

  set(value) {
    const passcode = value ? window.btoa(`:${value}`) : null;
    localstore.set(StorageKeys.PUBLIC_PASSCODE, passcode);
  },

  get() {
    return localstore.get(StorageKeys.PUBLIC_PASSCODE) || '';
  },

  remove() {
    localstore.remove(StorageKeys.PUBLIC_PASSCODE);
  },

};

const publicHash = {

  init(value) {
    localstore.set(StorageKeys.PUBLIC_HASH, value);
  },

  set(value) {
    localstore.set(StorageKeys.PUBLIC_HASH, value);
  },

  get() {
    return localstore.get(StorageKeys.PUBLIC_HASH) || '';
  },

  remove() {
    localstore.remove(StorageKeys.PUBLIC_HASH);
  },

};

// use cookie instead of LocalStorage b/c LS is cleared on login
const joinGroupIntent = {
  push(value) {
    document.cookie = `${StorageKeys.JOIN_GROUP_INTENT}=${value}; path=/`;
  },

  pop() {
    const cookies = document.cookie.split(';');
    let value;

    for (let cookie of cookies) {
      cookie = cookie.trim();

      if (cookie.startsWith(`${StorageKeys.JOIN_GROUP_INTENT}=`)) {
        value = cookie.substring(`${StorageKeys.JOIN_GROUP_INTENT}=`.length);
      }
    }

    document.cookie = `joinGroupIntent=; expires=${new Date(0).toUTCString()}; path=/`;
    return value ? Number(value) : undefined;
  },
};

const lastAccessedProfiles = {
  getAll() {
    const data = localstore.get(StorageKeys.LAST_ACCESSED_PROFILES);
    return Array.isArray(data) ? data : [];
  },

  update(profileId) {
    const data = localstore.get(StorageKeys.LAST_ACCESSED_PROFILES) || [];
    const arrayData = Array.isArray(data) ? data : [];
    const newData = arrayData.filter(id => id !== profileId);
    newData.unshift(profileId)

    localstore.set(StorageKeys.LAST_ACCESSED_PROFILES, newData);
  },
};

const logoutEvent = {
  init() {
  },

  set() {
    localstore.set(StorageKeys.LOGOUT_EVENT, true);
  },

  get() {
    return localstore.get(StorageKeys.LOGOUT_EVENT) || '';
  },

  remove() {
    localstore.remove(StorageKeys.LOGOUT_EVENT);
  },
};

const versionCheck = {
  init() {
  },

  set(value) {
    localstore.set(StorageKeys.VERSION_CHECK, value);
  },

  get() {
    return localstore.get(StorageKeys.VERSION_CHECK) || '0';
  },

  remove() {
    localstore.remove(StorageKeys.VERSION_CHECK);
  },
};

const deepLink = {
  init() {
  },

  set(value) {
    sessionstore.set(StorageKeys.DEEP_LINK, value);
  },

  get() {
    return sessionstore.get(StorageKeys.DEEP_LINK) || '';
  },

  remove() {
    sessionstore.remove(StorageKeys.DEEP_LINK);
  },
}

const activeProfile = {
  init() {
  },

  set(value) {
    if (Number(value) === value) {
      sessionstore.set(StorageKeys.ACTIVE_PROFILE, value);
    }
  },

  get() {
    return Number(sessionstore.get(StorageKeys.ACTIVE_PROFILE)) || null;
  },

  remove() {
    sessionstore.remove(StorageKeys.ACTIVE_PROFILE);
  },
}

const PersistantValues = [
  versionCheck,
];

export { StorageKeys, sessionstore, localstore, authToken, lastActiveTime, publicPasscode, publicHash, joinGroupIntent, lastAccessedProfiles, logoutEvent, versionCheck, deepLink, activeProfile };
